import type { InjectionKey } from 'vue'
import type { AppType } from '#shared/model/app-type'

export const appTypeInjectionKey = Symbol('appTypeInjectionKey') as InjectionKey<AppType>
